import React from 'react';
import { Field } from 'react-final-form';
import ScoreTypeSelector, { GqlScoreType } from '../ScoreTypeSelector';

interface FormScoreTypeSelectorProps {
  name: string;
  label?: string;
  showDescription?: boolean;
  disabled?: boolean;
}

const FormScoreTypeSelector: React.FC<FormScoreTypeSelectorProps> = ({
  name,
  label,
  showDescription = true,
  disabled = false
}) => {
  return (
    <Field name={name} initialValue={GqlScoreType.RISK}>
      {({ input, meta }) => (
        <ScoreTypeSelector
          name={input.name}
          value={input.value}
          onChange={input.onChange}
          label={label}
          showDescription={showDescription}
          disabled={disabled}
        />
      )}
    </Field>
  );
};

export default FormScoreTypeSelector;